import React, { Component } from 'react';
import brandLogo from '../images/brand-logo-inverse-dark.png';
import { translate } from 'react-i18next';
import { LANG } from '../App.js';
import { Link } from 'react-router-dom';

class Login extends Component {

  constructor(props) {
    super(props);

    window.fbLoaded.promise.then(() => {

      window.FB.XFBML.parse();
      // var spinner = document.getElementById("facebookSpinner");
      // spinner.removeAttribute("class");
      // spinner.removeChild(spinner.childNodes[0]);
    });

    let thiss = this;
    window.googleLoaded.promise.then(() => {
      this.initializeGoogle();
    });
  }


  initializeGoogle = () => {
    this.props.loadGoogle("LOGIN");
  }

  render() {
    const { t } = this.props;
    return (
      <div className="login-panel panel panel-default">
        <div className="panel-content">
          <div className="panel-heading-signup text-center">
            <img height="64px" alt="IOS OFFICES" src={brandLogo} />
          </div>
          <div className="panel-body-singup">
            <h4>{t('onboarding.login.heading')}</h4>
            <form method="post" onSubmit={this.props.handleLoginSubmit}>
              <fieldset>
                <div className="form-group">
                  <input className="form-control"
                    onChange={this.props.handleEmailChange}
                    placeholder={t('onboarding.login.holder_email')}
                    required
                    type="email"
                    value={this.props.email} />
                </div>
                <div className="form-group">
                  <input
                    className="form-control"
                    onChange={this.props.handlePasswordChange}
                    placeholder={t('onboarding.login.holder_password')}
                    required
                    type="password"
                    value={this.props.password} />
                </div>
                <div className={this.props.success ? "" : "hidden"}>
                  <div className="alert alert-success">
                    <i className="glyphicon glyphicon-remove pull-right" onClick={this.props.handleClearSuccess} />
                    {this.props.success}
                  </div>
                </div>
                <div className={this.props.error ? "" : "hidden"}>
                  <div className="alert alert-warning">
                    {this.props.error}
                    <i className="glyphicon glyphicon-remove pull-right" onClick={this.props.handleClearError} />
                  </div>
                </div>
                <div className="form-group">
                  <button
                    className="btn btn-block btn-primary btn-singup"
                    type="submit">
                    {t('onboarding.login.btn_login')}
                  </button>
                </div>
                {/* <div className="form-group full">                      
                  <div id="gSignInWrapper">
                    <div id="customBtn" className="customGPlusSignIn">
                      <span className="icon"></span>
                      <span className="buttonText">{t('onboarding.login.google')}</span>
                    </div>
                  </div>
              </div>
              <div className="form-group"> 
               <div>
                <div id="facebookSpinner" className="facebookSpinner">
                        <span>Loading</span>
                        <a href="" className="fb connect" onClick={this.props.loginWithFacebook}>{t('onboarding.login.facebook')}</a>
                </div> 
                </div>
              </div> */}
                <p className="small signup">
                  <button
                    className="btn btn-link btn_password"
                    disabled={!this.props.email}
                    onClick={this.props.handlePasswordReset}
                    type="button">
                    {t('onboarding.login.password')}
                  </button>
                </p>
              </fieldset>
            </form>
          </div>
          <div className="panel-footer-signup">
            <p className="small signup">{t('onboarding.login.signup')}</p>
            <div className="desktop_container movil_container">
              <div className="form-group">
                <button
                  className="btn btn-block btn-primary  btn-singup btn_create"
                  onClick={this.props.handleSignupClick}
                  type="button">
                  {t('onboarding.login.btn_signup')}
                </button>
              </div>
              <div className="form-group">
                <Link to="/store">
                  <button className="btn btn-block btn-primary btn-singup btn_resser">
                    {t('onboarding.booking.btn_book')}
                    <i className="glyphicon glyphicon-arrow-right" style={{ marginLeft: "10px" }} />
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default translate('common')(Login);



// WEBPACK FOOTER //
// ./src/onboarding/Login.js